import React from 'react';

type ChildrenProps = { children: React.ReactNode };

export const Row: React.FC<ChildrenProps> = ({ children }) => (
  <div className="package-editor-row-2 package-editor-row">{children}</div>
);

export const Label: React.FC<ChildrenProps & { required?: boolean }> = ({ children, required }) => (
  <label className={`package-editor-label${required ? ' required' : ''}`}>{children}</label>
);

export const Input: React.FC<React.InputHTMLAttributes<HTMLInputElement>> = ({ className = '', ...props }) => (
  <div className="package-editor-input-container">
    <input {...props} className={`package-editor-input ${className}`.trim()} />
  </div>
);

export const TextArea: React.FC<React.TextareaHTMLAttributes<HTMLTextAreaElement>> = ({ className = '', ...props }) => (
  <div className="package-editor-input-container">
    <textarea {...props} className={`package-editor-textarea ${className}`.trim()} />
  </div>
);

export const Section: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <div className="package-editor-section">
    <div className="package-editor-title">{title}</div>
    {children}
  </div>
);

export function TagInput({
  value,
  onChange,
  placeholder,
}: {
  value: string[];
  onChange: (v: string[]) => void;
  placeholder?: string;
}) {
  const [draft, setDraft] = React.useState('');
  const add = (v: string) => {
    const t = v.trim();
    if (!t) return;
    onChange(Array.from(new Set([...(value || []), t])));
    setDraft('');
  };
  const remove = (idx: number) => onChange(value.filter((_, i) => i !== idx));

  return (
    <div>
      <div className="package-editor-tag-input-container">
        <Input
          placeholder={placeholder || 'Type and press Enter'}
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              add(draft);
            }
          }}
        />
        <button
          type="button"
          className="package-editor-btn-primary"
          onClick={() => add(draft)}
        >
          Add
        </button>
      </div>
      <div className="package-editor-tags-container">
        {value?.map((t, i) => (
          <span
            key={`${t}-${i}`}
            className="package-editor-tag"
          >
            {t}
            <button
              type="button"
              className="package-editor-remove-btn"
              onClick={() => remove(i)}
              aria-label="remove"
            >
              ✕
            </button>
          </span>
        ))}
      </div>
    </div>
  );
}

const UIComponents = { Row, Label, Input, TextArea, Section, TagInput };
export default UIComponents;
